module.exports = __webpack_public_path__ + "static/img/AudienceMattersLogoWhite.545857b.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/AM_Logo_Final/White/AudienceMattersLogoWhite.png
// module id = 1557
// module chunks = 0